import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-newsletter-modal',
    templateUrl: './newsletter-modal.component.html',
    styleUrls: ['./newsletter-modal.component.scss'],
    standalone: false
})
export class NewsletterModalComponent implements OnInit {


  /**
   * Constructor
   *
   * @param activeModal
   */
  constructor(
    public activeModal: NgbActiveModal
  ) {

  }

  ngOnInit(): void {



  }

}
